import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";

const allOption = { label: "Select All", value: "*" };

const Option = ({ innerProps, label, isSelected }) => (
  <div
    {...innerProps}
    style={{ display: "flex", alignItems: "center", padding: "5px 10px", cursor: "pointer" }}
  >
    <input type="checkbox" checked={isSelected} onChange={() => {}} style={{ marginRight: 8 }} />
    <label style={{ margin: 0, cursor: "pointer" }}>{label}</label>
  </div>
);

const ReactMultiSelectCheckboxes = ({
  options = [],
  value = [],
  onChange,
  setState,
  placeholderButtonLabel = "Select...",
  getDropdownButtonLabel,
  styles,
  hideSearch,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const allOptions = [allOption, ...options];

  const buttonLabel = getDropdownButtonLabel
    ? getDropdownButtonLabel({ placeholderButtonLabel, value })
    : placeholderButtonLabel;

  const handleChange = (selected, actionMeta) => {
    if (onChange) {
      onChange.call({ setState, options: allOptions }, selected, actionMeta);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div ref={containerRef} className={className} style={{ position: "relative" }}>
      <button
        type="button"
        onClick={() => setIsOpen((o) => !o)}
        style={{ width: "100%", textAlign: "left" }}
      >
        {buttonLabel}
      </button>
      {isOpen && (
        <div style={{ position: "absolute", zIndex: 9999, width: "100%" }}>
          <Select
            isMulti
            options={allOptions}
            value={value}
            onChange={handleChange}
            menuIsOpen
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            isSearchable={!hideSearch}
            styles={styles}
            components={{ Option }}
          />
        </div>
      )}
    </div>
  );
};

export default ReactMultiSelectCheckboxes;
